import React, { useState } from "react";
import Modal from "../modal/Modal";
import { MODAL_TYPE, WAYS_TO_STYLE_OPEN_MODAL_EVENT } from "../../constants";
import { useRuntimeConstants } from "../../context/runtimeConstants/RuntimeConstantsContext";
import useEventBus from "../../hooks/useEventBus";
import { StylingLookWithStockPrice } from "../../types/productTypes/stylingLookProduct";

interface WaysToStyleModalData {
  selectedLook: StylingLookWithStockPrice;
  index: number;
}

const WaysToStyleModal: React.FC = () => {
  const { getTranslation } = useRuntimeConstants() as {
    getTranslation: (key: string) => string;
  };
  const [open, setOpen] = useState(false);
  const [contentLoaded, setContentLoaded] = useState(false);
  const [focusOnCloseElement, setFocusOnCloseElement] =
    useState<HTMLElement | null>(null);
  const [stylingLooksModalData, setStylingLooksModalData] =
    useState<WaysToStyleModalData | null>(null);
  const [modalId] = useState<string>(
    `${MODAL_TYPE.SIDE}${Math.floor(Math.random() * 10000)}`
  );

  useEventBus(
    WAYS_TO_STYLE_OPEN_MODAL_EVENT,
    ({
      focusOnCloseElement,
      data,
    }: {
      focusOnCloseElement: HTMLElement;
      data?: WaysToStyleModalData | null;
    }) => {
      setOpen(true);
      setContentLoaded(true);
      setFocusOnCloseElement(focusOnCloseElement);
      if (!data) {
        setStylingLooksModalData(null);
        return;
      }
      setStylingLooksModalData(data);
    },
    []
  );

  const renderContent = () => {
    if (!stylingLooksModalData) return null;

    const { selectedLook, index } = stylingLooksModalData;

    return (
      <div>
        <p>Clicked Index: {index}</p>
        {selectedLook.products.map((product, i) => (
          <div key={i}>
            <p>ProductName: {product.name}</p>
            <p>IsInStock: {product.isInStock ? "Yes" : "No"}</p>
            <p>Price: {product.productPrice?.current?.text || "N/A"}</p>
          </div>
        ))}
      </div>
    );
  };

  return (
    <Modal
      title={getTranslation("pdp_associated_buy_the_look_title")}
      open={open}
      focusOnClose={focusOnCloseElement}
      modalId={modalId}
      modalType={MODAL_TYPE.SIDE}
      closeModal={() => setOpen(false)}
      contentLoaded={contentLoaded}
    >
      {renderContent()}
    </Modal>
  );
};

export default WaysToStyleModal;
